import router, { resetRouter } from "./router";
import store from "./store";
import { toTree } from "@/utils/index";
import axios from "axios";
// import { Message } from 'element-ui'
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
// import { getToken } from '@/utils/auth' // get token from cookie
// import getPageTitle from '@/utils/get-page-title'
import { addLayout, filterAsyncRouter } from "@/utils/permission";





NProgress.configure({
  showSpinner: false,
}); // NProgress Configuration
// const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist
const menus = addLayout(store.state.user.menus);
const saveMenuData = filterAsyncRouter(menus);
resetRouter();
const fullPathStore = [
  "/createComponent/detail",
  "/createComponent/ourinformationCompany",
  "/createComponent/sendStatusInformation",
];
router.addRoutes(saveMenuData);
router.beforeEach(async (to, from, next) => {
  debugger
  // start progress bar
  NProgress.start();
  // set page title
  // document.title = getPageTitle(to.meta.title)
  if (to.path === "/login") {
    axios
      .get(process.env.VUE_APP_BASE_API + `/sys/menu/listMenuByUserId`)
      .then(({ data }) => {
        let path;
        if (data.respCode === "500") {
          next();
          return;
        }
        if(store.state.user.menus.length === 0){
          const menus = saveMenuDataAndAddRouters(data.data);
        }
        if (store.state.user.menus[0].children) {
          path =
            store.state.user.menus[0].path +
            "/" +
            store.state.user.menus[0].children[0].path;
        } else {
          path = saveMenuData[0].path;
        }
        NProgress.done();
        next({
          path: path,
        });
      })
      .catch((error) => {
        next();
      });
  } else {
    next();
  }
});
function saveMenuDataAndAddRouters(data) {
  let menus = toTree(data).children;
  let createFlag = menus.find(item => item.component === 'create');
  let routersMenu = [];
  if (createFlag) {
    routersMenu = router.options.routes.filter(item => {
      return item.hidden !== true;
    })
  } else {
    routersMenu = router.options.routes.filter(item => {
      return item.hidden !== true && !['/createHome', '/createComponent', '/createHome2', '/createComponentUnit'].includes(item.path);
    })
  }
  routersMenu = [...routersMenu, ...menus]
  store.commit("user/SET_MENUS", routersMenu);
  menus = addLayout(menus);
  const saveMenuData = filterAsyncRouter(menus);
  resetRouter()
  router.addRoutes(saveMenuData);
  return store.state.user;
}
router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
